var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Input',{attrs:{"input-class":"login","outlined":"","height":"56","radius":"16","tabindex":"1","background-color":"#EDF2F7","placeholder":"Type your message","value":_vm.text},on:{"input":function($event){_vm.text = $event},"enter":_vm.send,"focus":_vm.markAsReadMessage,"keydown":_vm.markAsReadMessage}})
}
var staticRenderFns = []

export { render, staticRenderFns }